'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildDefaultI18n = exports.combineReducersInApp = exports.combineReducers = exports.configureStore = undefined;

var _redux = require('redux');

Object.defineProperty(exports, 'combineReducers', {
  enumerable: true,
  get: function get() {
    return _redux.combineReducers;
  }
});

var _configureStore2 = require('./configureStore');

var _configureStore3 = _interopRequireDefault(_configureStore2);

var _reducers = require('@its/components/lib/reducers');

var _preferences = require('@its/components/lib/util/preferences');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.configureStore = _configureStore3.default;
var combineReducersInApp = exports.combineReducersInApp = function combineReducersInApp(reducers) {
  return (0, _redux.combineReducers)({
    user: _reducers.user,
    i18n: _reducers.i18n,
    theme: _reducers.theme,
    routing: _reducers.routing,
    form: _reducers.form,
    framework: (0, _redux.combineReducers)({ loader: _reducers.loader, snackBar: _reducers.snackBar }),
    app: (0, _redux.combineReducers)(reducers)
  });
};

var buildDefaultI18n = exports.buildDefaultI18n = function buildDefaultI18n(translations) {
  var locale = (0, _preferences.getLanguage)() || 'en';
  return {
    locale: locale,
    messages: translations[locale]
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/redux/lib/index.js
 ** module id = 180
 ** module chunks = 0
 **/